/**
 * Clerk authentication configuration
 * 
 * Our approach allows anonymous users to start the trademark filing process
 * but requires authentication for advanced features like portfolio management.
 * 
 * This maximizes lead capture while encouraging users to create accounts
 * for the full SaaS experience.
 */
const config = {
  // Only these specific routes require authentication
  protectedRoutes: [
    // Portfolio management (viewing all trademarks)
    '/dashboard/portfolio', 
    '/dashboard/portfolio/*',
    
    // Account settings
    '/dashboard/account',
    '/dashboard/account/*',
    
    // Billing and payment history
    '/dashboard/payments',
    '/dashboard/payments/*',
    
    // User profile
    '/profile',
    '/profile/*',
    
    // Marketing Ops Dashboard (admin-only, further gated in MarketingApp)
    '/marketing',
    '/marketing/*'
  ],
  
  // Routes that are part of the trademark filing process (accessible anonymously)
  // This is just for reference - no auth check is applied to these
  publicFilingRoutes: [
    '/dashboard',
    '/dashboard/upload',
    '/dashboard/business-info',
    '/dashboard/analysis',
    '/dashboard/countries',
    '/dashboard/payment',
    '/dashboard/status'
  ],
  
  // Clerk appearance customization
  appearance: {
    variables: {
      colorPrimary: '#3B82F6', // Blue to match IamSafeIP theme
      colorText: '#1F2937',
      borderRadius: '0.375rem',
    },
    elements: {
      formButtonPrimary: 'bg-blue-500 hover:bg-blue-600 text-white',
      card: 'bg-white shadow-md rounded-lg',
    }
  }
};

export default config;
